"use strict";

exports.__esModule = true;
exports.default = void 0;
var _tagTester = _interopRequireDefault(require("./_tagTester.js"));
var _isFunction = _interopRequireDefault(require("./isFunction.js"));
var _isArrayBuffer = _interopRequireDefault(require("./isArrayBuffer.js"));
var _stringTagBug = require("./_stringTagBug.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var isDataView = (0, _tagTester.default)('DataView');

// In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.
// Also, in cases where the native `DataView` is
// overridden we can't rely on the tag itself.
function alternateIsDataView(obj) {
  return obj != null && (0, _isFunction.default)(obj.getInt8) && (0, _isArrayBuffer.default)(obj.buffer);
}
var _default = exports.default = _stringTagBug.hasDataViewBug ? alternateIsDataView : isDataView;